import React from "react";
import { Button } from "antd";
import { ColumnType } from "antd/lib/table";
import { compact } from "lodash";
import { EMPTY } from "constants/common";
import { AiccLessonInformation } from "types/model/aiccLearningAssets";
import learningAssetStyles from "../LearningAssets.module.scss";
import styles from "./LessonInformation.module.scss";

interface ColumnHandlers {
  canManage: boolean;
  isActionDisabled: boolean;
  onEdit: (lesson: AiccLessonInformation) => void;
}

const renderCellText = (value: string) => (value ? <div className={styles.cellText}>{value}</div> : EMPTY);

export const previewColumns: ColumnType<AiccLessonInformation>[] = [
  { title: "Level", dataIndex: "level", key: "level", width: 80 },
  { title: "Lesson", dataIndex: "lesson", key: "lesson", width: 80 },
  { title: "Lesson Summary", dataIndex: "summary", key: "summary", width: 420, render: renderCellText },
  { title: "Key Vocabulary", dataIndex: "keyVocabulary", key: "keyVocabulary", width: 280, render: renderCellText },
];

const getColumns = ({ canManage, isActionDisabled, onEdit }: ColumnHandlers) =>
  compact<ColumnType<AiccLessonInformation>>([
    {
      title: "Level",
      dataIndex: "level",
      key: "level",
      width: 100,
      render: (level: number) => level ?? EMPTY,
    },
    {
      title: "Lesson",
      dataIndex: "lesson",
      key: "lesson",
      width: 100,
      render: (lesson: number) => lesson ?? EMPTY,
    },
    {
      title: "Lesson Summary",
      dataIndex: "summary",
      key: "summary",
      width: 520,
      render: renderCellText,
    },
    {
      title: "Key Vocabulary",
      dataIndex: "keyVocabulary",
      key: "keyVocabulary",
      width: 320,
      render: renderCellText,
    },
    canManage && {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: 100,
      render: (_: unknown, record: AiccLessonInformation) => (
        <Button
          type="link"
          className={learningAssetStyles.linkButton}
          disabled={isActionDisabled}
          onClick={() => onEdit(record)}
        >
          Edit
        </Button>
      ),
    },
  ]);

export default getColumns;
